import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import PropTypes from "prop-types";
import { SERVER_URL } from "../config/config";
import Popup from "reactjs-popup";

async function loginUser(credentials) {
  // https://run.mocky.io/v3/702e0d64-e1eb-4c63-b071-e4ad3e15acfc
  return fetch(SERVER_URL + "/login/access-token", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(credentials),
  }).then((data) => data.json());
}

export default function Login({ sessionObject }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [pageMode, setPageMode] = useState("");
  const [popupError, setPopupError] = useState("");
  const [loading, setLoading] = useState(false);

  let refStoreObject = useRef({});

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setPopupError("Username and password are required");
      setPageMode("error");
      return;
    }

    setLoading(true);

    try {
      const resp = await loginUser({
        username,
        password: password.toLowerCase(),
      });

      if ("detail" in resp) {
        let message = "Invalid credentials";
        if (resp.detail === "Exeption in login api") {
          message = "Invalid credentials";
        } else {
          message = resp.detail;
        }
        setPopupError(message);
        setPageMode("error");
        return;
      }

      if (!resp || typeof resp !== "object") {
        setPopupError("Unexpected server response");
        setPageMode("error");
        return;
      }

      resp.branch_id = resp.branch_id || null;
      resp.branch_name = resp.branch_name || null;

      sessionObject.saveSessionVariableByObject(resp);
      // console.log("SESSION OBJ", sessionObject);

    } catch (error) {
      console.error("Login error:", error);
      setPopupError("Server error. Please try again later.");
      setPageMode("error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(
    // Effect for clearing out client side validation
    () => {
      refStoreObject.current["username"].focus();
    },
    []
  );

  return (
    <div className="login-wrapper">
      <Popup
        open={pageMode == "error"}
        modal
        contentStyle={contentStyle}
        closeOnDocumentClick={false}
      >
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">
              {" "}
              {<div>Error Logging In</div>}
              <div>
                <a className="pop-up-close btn" onClick={close}>
                  &times;
                </a>
              </div>
            </div>
            {
              <div className="pop-up-content">
                <br />
                <div className="pop-up-fields">
                  <div className="pop-up-field">
                    <div className="pop-up-field-value">{popupError}</div>
                  </div>
                </div>
              </div>
            }
            <div className="pop-up-actions">
              <button
                className="pop-up-button"
                onClick={() => {
                  close();
                  setPageMode("");
                }}
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </Popup>
      <h1>Please Log In</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <p>Username</p>
          <input
            type="text"
            onChange={(e) => setUserName(e.target.value)}
            ref={(a) => (refStoreObject.current.username = a)}
            onKeyPress={(a) => {
              if (a.key == "Enter") {
                a.preventDefault();
                refStoreObject.current.password.focus();
              }
            }}
          />
        </label>
        <label>
          <p>Password</p>
          <input
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            ref={(a) => (refStoreObject.current.password = a)}
            onKeyPress={(a) => {
              if (a.key == "Enter") {
                a.preventDefault();
                refStoreObject.current.save_button.focus();
              }
            }}
          />
        </label>
        <div>
          <button
            type="submit"
            ref={(a) => (refStoreObject.current.save_button = a)}
            className="login-button"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Log In"}
          </button>
        </div>
      </form>
    </div>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
